import React, { ChangeEvent, FocusEvent } from 'react';
import { navigate } from 'gatsby';
import { useSearchBox } from 'react-instantsearch-hooks-web';
import SearchIcon from 'assets/icons/searchIcon.svg';
import { TextField } from 'components/text-field';
import paths from 'constants/paths';
import { classnames } from 'helpers/utils';
import * as styles from './search-styles.module.scss';

interface SearchBoxProps {
  className?: string;
  onChange?: (value: string) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
}

const SearchBox = ({
  className, onChange, onFocus,
}: SearchBoxProps) => {
  const { query, refine } = useSearchBox();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    refine(value);

    if (onChange) {
      onChange(value);
    }
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  const handleEnter = (e: React.KeyboardEvent <HTMLInputElement>) => {
    if (e.key === 'Enter') {
      navigate(`${paths.searchPageAll}${query}`);
    }
  };

  return (
    <form className={classnames(styles.searchBox, className || '')} onSubmit={(e) => handleSearch(e)}>
      <TextField
        name="search"
        placeholder="Search"
        onChange={handleChange}
        leftIcon={SearchIcon}
        value={query}
        className={styles.searchInput}
        onFocus={onFocus}
        onKeyDown={handleEnter}
      />
    </form>
  );
};

export default SearchBox;
